import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from 'constants/routes';
import { isITAREnvironment } from 'constants/env';

const SubscriptionsPlans = React.lazy(() => import('pages/subscriptionsPlans'));
const CheckEmail = React.lazy(() => import('pages/checkEmail'));
const ForgotPassword = React.lazy(() => import('pages/forgotPassword'));
const Login = React.lazy(() => import('pages/login'));
const ResetPassword = React.lazy(() => import('pages/resetPassword'));
const SignupPage = React.lazy(() => import('pages/signup'));
const SSOCallback = React.lazy(() => import('pages/ssoCallback'));

export const UnauthenticatedRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path={routes.login} element={<Login />} />
      <Route path={routes.signup} element={<SignupPage />} />
      <Route path={routes.forgotPassword} element={<ForgotPassword />} />
      <Route path={routes.checkEmail} element={<CheckEmail />} />
      <Route path={`${routes.resetPassword}/:userId/:token`} element={<ResetPassword />} />
      <Route path={routes.ssoCallback} element={<SSOCallback />} />
      {!isITAREnvironment() && (
        <Route
          path={`${routes.subscriptionsPlans}/auth`}
          element={<SubscriptionsPlans isAuthFlow />}
        />
      )}
      {!isITAREnvironment() && (
        <Route
          path="/subscriptions-plans/dashboard"
          element={<Navigate to="/subscriptions-plans/auth" />}
        />
      )}
      <Route
        path={`${routes.signup}/free`}
        element={<Navigate to={`${routes.signup}?subscription=free`} />}
      />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
};
